module.exports = require("@noble/hashes/utils");